import { createContext, useState, useContext, useEffect } from 'react';
import { MenuContext } from './MenuContext';
import { fileDownloadComponentLink } from '../ReactComponentLink';
import { useAxiosAuthenticated } from '../useAxiosAuthenticated';
import { ERROR_TEXT } from '../constants';

export const FileDownloadsContext = createContext();

export const FileDownloadsProvider = ({ children }) => {
    const { selectedMenuItem } = useContext(MenuContext);
    const [selectedFileDownload, setSelectedFileDownload] = useState(null);
    const [errorText, setErrorText] = useState('');
    const { get, post, tokenError } = useAxiosAuthenticated();

    // Entirety of cobrands available
    const [allValidCobrands, setAllValidCobrands] = useState([]);
    
    // Cobrands available for this file download
    const [cobrandOptions, setCobrandOptions] = useState([]);

    useEffect(() => {
        if (tokenError) setErrorText(ERROR_TEXT.token);
    }, [tokenError]);

    // Fetch all cobrands
    useEffect(() => {
        if (!get) return;
        
        const makeCobrandsRequest = async () => {
            try {
                setErrorText('');
                const url = process.env.REACT_APP_API_BASE_URL + '/staff/cobrands';
                const resp = await get(url);
                const newCobrandOptions = resp.data.map((x) => ({
                    id: x.cobrandId,
                    name: x.name,
                }));
                setAllValidCobrands(newCobrandOptions);
            } catch (error) {
                console.error(error);
                setErrorText(ERROR_TEXT.cobrands);
            }
        };
        makeCobrandsRequest();
    }, [get]);

    // Set cobrandOptions to all available cobrands
    useEffect(() => {
        if (!allValidCobrands.length) return;
        setCobrandOptions(allValidCobrands);
    }, [allValidCobrands]);

    // Update selected file download when menu item changes
    useEffect(() => {
        if (selectedMenuItem?.pageType === 'file-downloads') {
            const component = fileDownloadComponentLink[selectedMenuItem.slug];
            if (component) {
                setSelectedFileDownload({
                    slug: selectedMenuItem.slug,
                    name: selectedMenuItem.name,
                    pageComponent: component,
                });
            } else {
                setSelectedFileDownload(null);
            }
        }
    }, [selectedMenuItem]);

    return (
        <FileDownloadsContext.Provider
            value={{
                selectedFileDownload,
                cobrandOptions,
                errorText,
            }}
        >
            {children}
        </FileDownloadsContext.Provider>
    );
};
